import React from 'react';

import TextCell from 'components/Pages/Admin/PageTypes/shared/TextCell';
import Button from 'components/shared/Button';
import CheckBox from 'components/shared/FormAdapters/FormDefault/CheckBox';
import Icon from 'components/shared/Icon';
import Visibility from 'components/shared/Icon/icons/Visibility';
import ColHeader from 'components/shared/Table/ColHeader';
import { formatDate } from 'utils/date';

import styles from './index.module.css';
import types from './types';

const withColHeaderWrapper = (title, orderBy, order, onOrder) => (tableInst) => (
  <ColHeader title={title} orderBy={orderBy} order={order} onOrder={onOrder} {...tableInst} />
);

const getColumns = ({ selected, params, onSelect, onView, onEdit, onApprove, onReject, onOrder }) => {
  const getOrderedColHeader = (name) => withColHeaderWrapper(name, params.orderBy, params.order, onOrder);

  return [
    {
      Header: getOrderedColHeader('Title'),
      accessor: 'name',
      growFactor: 1.5,
      Cell: ({ cell, row }) => {
        return (
          <div className={styles.nameCell}>
            <CheckBox
              onChange={() => onSelect(row.original.id)}
              checked={selected.includes(row.original.id)}
              noMargin
              size="sm"
              className={styles.nameCheckbox}
            />
            <div className={styles.nameTextWrapper}>
              <TextCell text={cell.value} />
            </div>
          </div>
        );
      },
    },
    {
      Header: getOrderedColHeader('Owner'),
      accessor: 'creatorEmail',
      growFactor: 1.5,
      Cell: ({ row }) => <TextCell text={row.original.creator.email} />,
    },
    {
      Header: getOrderedColHeader('Content Type'),
      accessor: 'type',
      growFactor: 1.3,
      Cell: ({ cell }) => <TextCell text={types[cell.value] || types.unknown} />,
    },
    {
      Header: getOrderedColHeader('@Handle'),
      accessor: 'handle',
      growFactor: 1.3,
      Cell: ({ cell }) => <TextCell text={`@${cell.value}`} />,
    },
    {
      Header: getOrderedColHeader('Date Created'),
      accessor: 'createdAt',
      growFactor: 1.3,
      Cell: ({ cell }) => <TextCell text={formatDate(new Date(cell.value))} />,
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      fixedSize: '204px',
      Cell: ({ row }) => {
        return (
          <div className={styles.actionButtons}>
            <Icon component={Visibility} width="1.6rem" fill="#c4c4c4" onClick={() => onView(row.original)} />
            <Button type="default" size="small" onClick={() => onEdit(row.original.id)} children="Edit" />
            <Button type="default" size="small" onClick={() => onApprove(row.original.id)} children="Approve" />
            <Button type="default" size="small" onClick={() => onReject(row.original.id)} children="Reject" />
          </div>
        );
      },
    },
  ];
};

export default getColumns;
